<template>
    <el-cascader
        v-if="props.type === 'team'"
        :model-value="props.modelValue"
        :options="depList"
        placeholder="请输入"
        clearable
        :show-all-levels="props.multiple"
        filterable
        :style="props.cssStyle"
        collapse-tags
        :max-collapse-tags="0"
        :props="{
            multiple: props.multiple,
            checkStrictly: true,
            emitPath: false,
            value: 'id',
            label: 'name',
            children: 'childs',
            disabled: 'dis'
        }"
        @change="handleChange"
    />
    <el-select
        v-else
        class="input selectTags"
        :style="props.cssStyle"
        :model-value="props.modelValue"
        :multiple="props.multiple"
        collapse-tags
        :max-collapse-tags="1"
        collapse-tags-tooltip
        filterable
        remote
        :clearable="props.clearable"
        reserve-keyword
        placeholder="请选择"
        :remote-method="getOptionFilter"
        :loading="selecting"
        @change="handleChange"
    >
        <el-option
            v-for="item in state.queryOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
        />
    </el-select>
</template>

<script setup>
import { ref, reactive, computed } from 'vue';
import { useStore } from 'vuex';
import { throttle } from '@/utils';
import axios from '@/plugins/axios';

const store = useStore();
const depList = computed(() => store.getters.depList);

const props = defineProps({
    modelValue: {
        type: [String, Number, Boolean],
        default: () => ''
    },
    type: {
        type: String,
        default: () => ''
    },
    multiple: {
        type: Boolean,
        default: () => false
    },
    clearable: {
        type: Boolean,
        default: () => false
    },
    cssStyle: {
        type: Object,
        default: () => ({})
    },
    fetchOptions: {
        type: Function,
        default: async(key) => {
            // 默认是获取IT负责人
            const res = await axios({
                url: '/bp/budget/presentation/getUser',
                method: 'get',
                params: {
                    key,
                    pageSize: 50,
                    pageNum: 1
                }
            });
            const { data = {}} = res;
            return data.items.slice(0, 50).map(it => ({
                label: `${it.nickName}-${it.empNo}-${it?.userOrgEHRs?.[0]?.orgName ?? ''}`,
                value: `${it.nickName}-${it.empNo}-${it?.userOrgEHRs?.[0]?.orgName ?? ''}`
            }));
        }
    }
});

const selecting = ref(false);
const state = reactive({
    queryOptions: []
});

const getOptionFilter = throttle(async(query) => {
    if (query) {
        selecting.value = true;
        props.fetchOptions(query).then(newOptions => {
            selecting.value = false;
            state.queryOptions = newOptions;
        });
    } else {
        state.queryOptions = [];
    }
}, 200);

const emits = defineEmits(['update:modelValue']);
const handleChange = (val) => {
    emits('update:modelValue', val);
};
</script>

<style lang="scss" scoped>

</style>
